Currency = require 'models/currency.coffee'

module.exports = class Account
  @className: 'Account'
  isNew: -> _.isNil(@id)
  constructor: (obj) ->
    _.merge(@, obj)
    return @
  universalBalance: (convert_to_currency) -> Currency.convert(@balance, @currency, convert_to_currency)
  fUniversalBalance: ->
    Currency.format
      value: @universalBalance(HM.store.getters.default_currency)
      currency: HM.store.getters.default_currency
  isInBudget: -> @is_in_budget == true
  name_and_balance: -> return "#{@name} (#{@fBalance()})"
  available_credit: -> @credit_limit + @balance
  fBalance: ->
    Currency.format
      value: @balance
      currency: @currency
  over_budget: -> @credit_limit && @available_credit() < 0

  fCategory: -> HM.store.getters.account_categories_find(@account_category)
  isHidden: -> !@fCategory().selectable

  @newRecord: (user) ->
    attrs =
      id: null
      balance: 0
      currency: user.userdata.default_currency
      account_category: HM.store.getters.account_categories_visible[0]?.id
      name: ''
      is_in_budget: true
      position: -1
      description: ''
      credit_limit: 0
    new Account(attrs)
